const breadCrumb = "Lotação de Servidores - Manutenção do Servidor";
const parentRoute = "/cadastro-de-servidor";

const routes = [
  {
    path: "/servidor/:servidorId/manutencao-de-ocorrencias-funcionais-do-servidor",
    name: "manutencao-de-ocorrencias-funcionais-do-servidor",
    meta: {
      allowedPermissions: ["ocorrencias_servidor_list"],
      breadCrumb: breadCrumb,
      parentRoute: parentRoute,
      pageTitle: "Ocorrências Funcionais do Servidor",
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/ManutencaoDeOcorrenciasFuncionaisDoServidor/ManutencaoDeOcorrenciasFuncionaisDoServidorHome.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/manutencao-de-ocorrencias-funcionais-do-servidor/novo",
    name: "manutencao-de-ocorrencias-funcionais-do-servidor-novo",
    meta: {
      allowedPermissions: ["ocorrencias_servidor_insert"],
      breadCrumb: breadCrumb,
      parentRoute: parentRoute,
      pageTitle: "Ocorrências Funcionais do Servidor - Novo",
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/ManutencaoDeOcorrenciasFuncionaisDoServidor/ManutencaoDeOcorrenciasFuncionaisDoServidorCad.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/manutencao-de-ocorrencias-funcionais-do-servidor/editar/:id",
    name: "manutencao-de-ocorrencias-funcionais-do-servidor-editar",
    meta: {
      allowedPermissions: ["ocorrencias_servidor_update"],
      breadCrumb: breadCrumb,
      parentRoute: parentRoute,
      pageTitle: "Ocorrências Funcionais do Servidor - Editar",
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/ManutencaoDeOcorrenciasFuncionaisDoServidor/ManutencaoDeOcorrenciasFuncionaisDoServidorEdit.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/manutencao-de-ocorrencias-funcionais-do-servidor/visualizar/:id",
    name: "manutencao-de-ocorrencias-funcionais-do-servidor-visualizar",
    meta: {
      allowedPermissions: ["ocorrencias_servidor_show"],
      breadCrumb: breadCrumb,
      parentRoute: parentRoute,
      pageTitle: "Ocorrências Funcionais do Servidor - Visualizar",
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/ManutencaoDeOcorrenciasFuncionaisDoServidor/ManutencaoDeOcorrenciasFuncionaisDoServidorShow.vue"
      ),
  },
];

export default routes;
